import { Container, Typography } from "@mui/material";
import Image from "next/image";
import { useContext } from "react";
import { LocalizationContext } from "../../lib/context";
import { keyBy, merge, values } from "lodash";

const bannerSectionData = [
  {
    blockId: "contact",
    icon: "/assets/PleaseContactIcon.svg",
  },
  {
    blockId: "ask",
    icon: "/assets/JustAsk.svg",
  },
  {
    blockId: "brokerage",
    icon: "/assets/FeePercentage.svg",
  },
];

const DronersInfoSection = () => {
  const { dronersPage } = useContext(LocalizationContext).localeStrings;
  const localizedBannerTexts = dronersPage.bannerSection;
  const mergedBannerData = values(
    merge(
      keyBy(localizedBannerTexts, "blockId"),
      keyBy(bannerSectionData, "blockId")
    )
  );
  return (
    <div className="inspire__info">
      <Container className="inspire__info--content">
        <div>
          <Typography
            color="primary.light"
            fontWeight="600"
            sx={{ fontSize: 24 }}
            mb={2}
            children={dronersPage.pageTitle}
          />

          <Typography
            color="primary.light"
            fontWeight="700"
            variant="h2"
            sx={{ fontSize: 34 }}
            m={0}
            children={dronersPage.subtitle}
          />
        </div>

        <div className="inspire__info--items">
          {mergedBannerData.map((item) => (
            <div className="inspire__info--item" key={item.blockId}>
              <div className="inspire__info--item-header">
                <Image
                  src={item.icon}
                  alt="color-palette"
                  width="32"
                  height="32"
                />
                <Typography variant="h2" color="white">
                  {item.header}
                </Typography>
              </div>

              <Typography
                color="white"
                variant="subtitle1"
                className="inspire__info--item-text"
                children={item.text}
              />
            </div>
          ))}
        </div>
      </Container>
    </div>
  );
};

export default DronersInfoSection;
